import {BehaviorSubject, Observable} from "rxjs";
import r2Core from "@core/r2";
import {IOfficeChatSetting} from "./office-chat-setting-v1.types";
import Office from "@core/shared/office.instance";

export const OFFICE_KNOWLEDGE = {
    local: 'local',
    global: 'global',
    both: 'both'
}

export const OFFICE_SLOT = {
    main: 'main',
    stage: 'stage',
}

export const MANIFEST_VERSION = '1.2.1'

export const SETTING_TONE = r2Core.constants.chat.SETTING_TONE;
export const SETTING_TOKEN_LENGTH = r2Core.constants.chat.SETTING_TOKEN_LENGTH;
export const SETTING_MODEL = r2Core.constants.chat.SETTING_MODEL

export class OfficeChatSettingV1 {
    public $setting: BehaviorSubject<IOfficeChatSetting> = new BehaviorSubject<IOfficeChatSetting>({
        office_host: Office.HostType.Outlook,
        office_platform: Office.PlatformType.OfficeOnline,
        manifest_version: MANIFEST_VERSION,
        knowledge: OFFICE_KNOWLEDGE.global,
        max_tokens: SETTING_TOKEN_LENGTH.medium,
        slot: OFFICE_SLOT.main,
        role_information: SETTING_TONE.FORMAL,
        model: SETTING_MODEL.GPT_41
    });
    constructor() {
        this.initData();
    }

    private async initData(): Promise<void> {
        const officeInfo = await Office.onReady();
        const setting = this.$setting.getValue()
        const updateSetting = {
            ...setting,
            office_host: officeInfo.host,
            office_platform: officeInfo.platform
        }
        this.$setting.next(updateSetting);
    }

    protected get(): IOfficeChatSetting {
        return this.$setting.getValue()
    }

    protected $get(): Observable<IOfficeChatSetting> {
        return this.$setting.asObservable();
    }

    protected set(newSetting: IOfficeChatSetting): IOfficeChatSetting {
        const oldSetting = this.get();
        const nextSetting = {
            ...oldSetting,
            ...newSetting
        }
        this.$setting.next(nextSetting);
        return newSetting
    }
}
